module.exports = __webpack_public_path__ + "img/alert.7f4c39c8.svg";